import { formatDate } from '../../../utils/helper';

export default function getDateRangeString(start: Date | string, end: Date | string): string {
  let string = '';
  if (start) {
    string += formatDate(start);
  } else {
    return string;
  }
  if (end) {
    string += `- ${formatDate(end)}`;
  }
  return string;
}
